import { LegalPage } from '@/pages/LegalLayout';

export default function Privacy() {
  return <LegalPage base="legal.privacy" />;
}
